import React from 'react';
import { Grid, Loading, PageLayout, Spacer } from '@arrow-ds/react';
import useGetRateData from 'src/hooks/useGetRateData';
import './App.scss';
import FTAModeller from '../../components/FTAModeller/FTAModeller';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';


const App = () => {
  const calculatorData = useGetRateData();

  return (
    <Grid container>
      <PageLayout className="importantInfoContent" documentTitle="Guaranteed Income Plan Calculator" pageTitle="Guaranteed Income Plan Calculator">
        <Grid container>
          <p>This calculator allows you to see the guaranteed income and/or lump sum that can be provided by our Guaranteed Income Plan for a range of different
            scenarios. Using current pricing, we show you a result based on the information you provide. You can use these results to narrow your options before going
            on to request a guaranteed quotation from us using our online quotation tool. The results shown are not a guaranteed quotation.
          </p>
          <Spacer spacing="medium" />
          {calculatorData?.status === 'error' && <ErrorComponent />}
          {calculatorData?.status === 'loading' && <Loading inline show />}
          {calculatorData?.status === 'success' && <FTAModeller calculatorData={calculatorData.data} />}
          <Spacer spacing="medium" />
          <div id="importantInfo">
            <Grid row>
              <Grid col={12}>
                <div className="importantInfoHeader">
                  <div className="importantInfoTitle">
                    <span className="ds-ml-3">Important information</span>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid row>
              <Grid col={12}>
                <div className="importantInfoContent ds-ui-xsmall">
                  <p>
                    This calculator is designed to give a general demonstration of how the Guaranteed Income Plan can be used as a retirement solution for members of
                    defined contribution pension schemes, particularly self-invested personal pensions (SIPPs). It does not take into consideration the member’s individual
                    circumstances or the impact on their tax position and should not be taken as offering advice or any recommendation. It should not be used in place of a
                    guaranteed quotation.
                  </p>
                  <p>
                    The results shown do not suggest any recommendation from Prudential. Every care has been taken as to its accuracy, but it must be appreciated that
                    neither Prudential nor its representatives can accept any responsibility for loss, however caused, suffered by any person who has acted or refrained
                    from acting as a result of material contained within this calculator.
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <br />
      </PageLayout>
    </Grid>
  );
};

export default App;
